export default __webpack_public_path__ + "static/landscapes-sixth-156eafbc02f1fb2b4bd30eae83782b31.webp";